class CollectionLoadMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-load-more]');
    this.status = this.querySelector('[data-load-status]');
    this.nextUrl = this.dataset.nextUrl;
    this.loadedUrls = new Set();
    this.isLoading = false;

    if (!this.button || !this.nextUrl) return;

    this.onClick = this.onClick.bind(this);
    this.button.addEventListener('click', this.onClick);

    if (this.dataset.mode === 'infinite' && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.loadNextPage();
        },
        { rootMargin: '500px 0px' },
      );
      this.observer.observe(this);
    }
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
    this.observer?.disconnect();
  }

  onClick(event) {
    event.preventDefault();
    this.loadNextPage();
  }

  async loadNextPage() {
    if (this.isLoading || !this.nextUrl || this.loadedUrls.has(this.nextUrl)) return;

    const requestedUrl = this.nextUrl;
    this.isLoading = true;
    this.classList.add('is-loading');
    this.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(requestedUrl);
      if (!response.ok) throw new Error(`Collection page request failed: ${response.status}`);

      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incomingGrid = documentFragment.querySelector('#product-grid');
      const currentGrid = document.querySelector('#product-grid');
      if (!incomingGrid || !currentGrid) throw new Error('Collection product grid was not found.');

      const newProducts = Array.from(incomingGrid.children);
      newProducts.forEach((product) => currentGrid.append(product));
      this.loadedUrls.add(requestedUrl);

      const incomingLoader = documentFragment.querySelector('collection-load-more');
      this.nextUrl = incomingLoader?.dataset.nextUrl || '';
      this.dataset.nextUrl = this.nextUrl;

      if (this.nextUrl) {
        this.button.href = this.nextUrl;
      } else {
        this.button.hidden = true;
        this.observer?.disconnect();
      }

      this.status.textContent = this.dataset.productCountTemplate.replace('[count]', newProducts.length);
      history.replaceState(history.state, '', requestedUrl);
    } catch (error) {
      console.error(error);
      this.status.textContent = this.dataset.loadError;
    } finally {
      this.isLoading = false;
      this.classList.remove('is-loading');
      this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('collection-load-more')) {
  customElements.define('collection-load-more', CollectionLoadMore);
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-collection-intro]').forEach((intro) => {
    const button = intro.querySelector('[data-intro-toggle]');
    const content = intro.querySelector('[data-intro-content]');
    if (!button || !content) return;
    const showMoreText = button.textContent.trim();
    const showLessText = button.dataset.showLess;

    button.hidden = content.scrollHeight <= content.clientHeight + 1;

    button.addEventListener('click', () => {
      const expanded = intro.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded.toString());
      button.textContent = expanded ? showLessText : showMoreText;
    });
  });
});
